module.exports = __webpack_public_path__ + "static/media/icon-plus1.4a3aed88.svg";